export default function CalenderIcon({
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill="#F4FDFF"
        d="M18.386 20.043h-16.5a.977.977 0 0 1-.976-.977V3.518c0-.54.437-.977.977-.977h16.5c.538 0 .976.437.976.977v15.548c0 .54-.437.977-.977.977Z"
      />
      <path
        fill="#E6E6E6"
        d="M18.777 2.541h-1.172c.54 0 .977.437.977.977v15.548c0 .54-.437.977-.977.977h1.172c.54 0 .977-.437.977-.977V3.518a.977.977 0 0 0-.977-.977Z"
      />
      <path
        fill="#ED6479"
        d="M18.386 2.539h-.541l-.927.39-.927-.39H12.04l-.927.39-.927-.39H6.235l-.927.39-.927-.39H1.887a.977.977 0 0 0-.977.977V6.75h18.453V3.516a.977.977 0 0 0-.977-.977Z"
      />
      <path
        fill="#D65461"
        d="M18.777 2.539h-1.172c.54 0 .977.437.977.977V6.75h1.172V3.516a.977.977 0 0 0-.977-.977Z"
      />
      <path
        fill="#FE646F"
        d="M16.918 4.451a.927.927 0 0 0 .927-.927V2.54H15.99v.985c0 .512.415.927.927.927Z"
      />
      <path
        fill="#D65461"
        d="M11.113 4.451a.927.927 0 0 0 .927-.927V2.54h-1.853v.985c0 .512.414.927.926.927Zm-5.805 0a.927.927 0 0 0 .926-.927V2.54H4.381v.985c0 .512.415.927.927.927Z"
      />
      <path
        fill="#99DBFB"
        d="M10.332 4.451a.927.927 0 0 1-.927-.927v-1.97c0-.512.415-.927.927-.927s.888.415.888.927v1.97c0 .512-.376.927-.888.927Zm-5.806 0a.927.927 0 0 1-.926-.927v-1.97c0-.512.415-.927.926-.927.512 0 .888.415.888.927v1.97c0 .512-.376.927-.888.927Zm11.61 0a.927.927 0 0 1-.926-.927v-1.97c0-.512.415-.927.927-.927s.888.415.888.927v1.97c0 .512-.376.927-.888.927Z"
      />
      <path
        fill="#7BB5F9"
        d="M16.138.627a.924.924 0 0 0-.332.061c.347.134.594.471.594.866v1.97a.927.927 0 0 1-.594.866.927.927 0 0 0 1.259-.865V1.553a.927.927 0 0 0-.927-.927Zm-5.807 0A.925.925 0 0 0 10 .688c.348.134.595.471.595.866v1.97a.927.927 0 0 1-.595.866.927.927 0 0 0 1.259-.865V1.553a.927.927 0 0 0-.927-.927Zm-5.805 0a.925.925 0 0 0-.332.061c.348.134.595.471.595.866v1.97a.927.927 0 0 1-.595.866.927.927 0 0 0 1.259-.865V1.553a.927.927 0 0 0-.927-.927Z"
      />
      <path
        fill="#ED6479"
        d="M17.655 12.527h-3.168a.206.206 0 0 1-.206-.205V9.154c0-.114.092-.206.206-.206h3.168c.114 0 .206.092.206.206v3.167a.206.206 0 0 1-.206.206Zm-5.74 5.37H8.749a.206.206 0 0 1-.206-.206v-3.168c0-.114.092-.206.206-.206h3.168c.113 0 .206.092.206.206v3.168a.206.206 0 0 1-.206.206Zm-5.739 0H3.01a.206.206 0 0 1-.206-.206v-3.168c0-.114.092-.206.206-.206h3.167c.114 0 .206.092.206.206v3.168a.206.206 0 0 1-.206.206Zm11.479 0h-3.168a.206.206 0 0 1-.206-.206v-3.168c0-.114.092-.206.206-.206h3.168c.114 0 .206.092.206.206v3.168a.206.206 0 0 1-.206.206Z"
      />
      <path
        fill="#F9D065"
        d="M11.916 12.527H8.748a.206.206 0 0 1-.206-.205V9.154c0-.114.092-.206.206-.206h3.168c.113 0 .206.092.206.206v3.167a.206.206 0 0 1-.206.206Zm-5.74 0H3.01a.206.206 0 0 1-.206-.205V9.154c0-.114.092-.206.206-.206h3.167c.114 0 .206.092.206.206v3.167a.206.206 0 0 1-.206.206Z"
      />
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={0.586}
        d="M14.045 6.75h5.709M.91 6.75h11.858m2.585 13.293H1.887a.977.977 0 0 1-.977-.977v-8.092M3.6 2.54H1.887a.977.977 0 0 0-.977.976v6.18m8.495-7.154H5.453m4.88 1.91a.927.927 0 0 1-.928-.927v-1.97a.927.927 0 0 1 1.854 0v1.97a.927.927 0 0 1-.927.927Z"
      />
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={0.586}
        d="M4.526 4.451a.927.927 0 0 1-.926-.927v-1.97a.927.927 0 0 1 1.853 0v1.97a.927.927 0 0 1-.927.927Zm11.61 0a.927.927 0 0 1-.926-.927v-1.97a.927.927 0 1 1 1.854 0v1.97a.927.927 0 0 1-.927.927Zm1.519 8.076h-3.168a.206.206 0 0 1-.206-.205V9.154c0-.114.092-.206.206-.206h3.168c.114 0 .206.092.206.206v3.167a.206.206 0 0 1-.206.206Zm-5.74 5.37H8.749a.206.206 0 0 1-.206-.206v-3.168c0-.114.092-.206.206-.206h3.168c.113 0 .206.092.206.206v3.168a.206.206 0 0 1-.206.206Zm-5.739 0H3.01a.206.206 0 0 1-.206-.206v-3.168c0-.114.092-.206.206-.206h3.167c.114 0 .206.092.206.206v3.168a.206.206 0 0 1-.206.206Zm11.479 0h-3.168a.206.206 0 0 1-.206-.206v-3.168c0-.114.092-.206.206-.206h3.168c.114 0 .206.092.206.206v3.168a.206.206 0 0 1-.206.206Zm-5.74-5.37H8.749a.206.206 0 0 1-.206-.205V9.154c0-.114.092-.206.206-.206h3.168c.113 0 .206.092.206.206v3.167a.206.206 0 0 1-.206.206Zm-5.739 0H3.01a.206.206 0 0 1-.206-.205V9.154c0-.114.092-.206.206-.206h3.167c.114 0 .206.092.206.206v3.167a.206.206 0 0 1-.206.206Z"
      />
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={0.586}
        d="m4.134 10.738.85.834L6.961 9.58m3.174 1.158.85.834 1.978-1.992m2.245-7.039h-3.951m5.372 17.502h2.147c.54 0 .976-.437.976-.977V3.518a.977.977 0 0 0-.976-.977h-1.713"
      />
    </svg>
  );
}
